import builder from '../builder';
import PaymentPaypal from '../../streamline-icons/bold/payment-paypal.svg';

export default builder('IconPaymentPaypalBold', PaymentPaypal);
